<template>
  <div class="file-uploader">
    <p class="text-p-bold file-uploader-title">Upload <span style="color: #EA5252">*</span></p>
    <div v-if="file_from_server.name && !file.length" class="file-uploader-load">
      <img width="56" height="56" src="~@/assets/file-preview.svg" alt="File preview icon"/>
      <div class="file-uploader-load-info">
        <p style="word-break: break-all" class="text-p">{{file_from_server.name}}</p>
        <p class="text-p load-size">{{countSize(file_from_server.size)}}</p>
      </div>
      <div class="delete-upload-wrap">
        <div class="delete-upload" @click="onDeleteFromServer">
          <i class="fak fa-trash-can-light"/>
        </div>
      </div>
    </div>
    <div v-if="file.length && valueSize > 25" class="error-block">
      <p>The file size must be less than 25 MB</p>
    </div>
    <div v-if="!file.length && !file_from_server.name " :class="['file-uploader-body', $refs.uploader?.dropActive && 'active']">
      <p class="text-p">
        <upload-component
          ref="uploader"
          :value="file"
          @input="onUpload"
          :accept="'application/pdf'"
          :multiple="false"
          :drop="true">
          Choose a file
        </upload-component>
        &nbsp;or drag it here
      </p>
    </div>
    <div v-if="file.length" :class="['file-uploader-load']">
      <img width="56" height="56" src="~@/assets/file-preview.svg" alt="File preview icon"/>
      <div class="file-uploader-load-info">
        <p style="word-break: break-all" class="text-p">{{info.name}}</p>
        <p class="text-p load-size">{{size}}</p>
        <div class="load-progress">
          <div :style="{width: `calc(100% * (${progress} / 100))`}" class="load-progress-bar"/>
          <p class="text-p">{{progress}}%</p>
        </div>
      </div>
      <div class="delete-upload-wrap">
        <div class="delete-upload" @click="onDelete"><i class="fak fa-trash-can-light"/></div>
      </div>
    </div>
    <div class="file-uploader-info">
      <div class="file-uploader-info-title">
        <div class="icon">
          <i style="color: #666; margin-right: 8px" class="fak fa-circle-info-light"/>
        </div>
        <div class="text">
          <p>Reward downloadable file requirements</p>
        </div>
      </div>
      <div class="file-uploader-info-body">
        <ul>
          <li>• The file size must be less than 25 MB</li>
          <li>• Acceptable file format - pdf</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import UploadComponent from 'vue-upload-component'
import PreviewImage from "@/components/UploadFilesMultipart/PreviewImage";
import api_requests from "../../store/api/api_requests";
export default Vue.extend({
  components: {
    UploadComponent,
    PreviewImage
  },
  props: {
    file: {
      type: Array
    },
    file_from_server: {
      default: {}
    }
  },
  data() {
    return {
      progress: 0,
      intervalId: null,
      fileValue: null,
      errors: null
    }
  },
  computed: {
    info() {
      return this.file.length ? this.file[0] : null
    },
    size() {
      const mb = this.info.size / 1000000
      const kb = this.info.size / 1000
      if (kb < 1000) return `${Math.round(kb)} KB`
      return `${mb.toFixed(1)} MB`
    },
    valueSize () {
      const mb = this.info.size / 1000000
      return mb.toFixed(1)
    }
  },
  methods: {
    countSize(byte) {
      const mb = byte / 1000000
      const kb = byte / 1000
      if (kb < 1000) return `${Math.round(kb)} KB`
      return `${mb.toFixed(1)} MB`
    },
    onUpload(value) {
      this.clearProgress()
      this.fileValue = value[0].file
      this.$emit('on-upload', value)
    },
    onDeleteFromServer() {
      this.errors = null
      this.$emit('on-delete-from-server')
    },
    onDelete() {
      this.errors = null
      this.clearProgress()
      this.$emit('on-delete')
    },
    clearProgress() {
      if (this.intervalId) clearInterval(this.intervalId)
    },
    saveFile() {
      return new Promise((resolve, reject) => {
        if (this.fileValue && !this.file_from_server) {
          let data = new FormData();
          data.append('file', this.fileValue)
          api_requests.upload_file(data)
              .then(response => {
                this.$emit('reward-file-set', response.data.path)
                resolve(response);
              })
              .catch(error => {
                this.errors = error.response.data.errors
                reject()
              })
        } else {
          resolve({
            data: this.file_from_server
          })
        }
      })
    }
  },
  watch: {
    file(value) {
      if (!value.length) this.progress = 0
      else {
        this.intervalId = setInterval(() => {
          if (this.progress === 100) this.clearProgress()
          else this.progress += 10
        }, 200)
      }
    }
  },
})
</script>
<style lang="scss" scoped>;
.file-uploader {
  &-title {
    margin-bottom: 8px;
  }
  &-body {
    width: 100%;
    height: 100px;
    padding: 10px 10px 10px 16px;
    border-radius: 8px;
    border: 1px dashed $color-secondary-text;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s ease-in;
    &.active {
      background-color: $color-blue-light;
    }
    p {
      display: flex;
      flex-wrap: wrap;
    }
    .file-uploads-drop {
      text-decoration-line: underline;
    }
  }
  &-load {
    width: 100%;
    min-height: 100px;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid $color-secondary-text;
    display: flex;
    gap: 20px;
    align-items: center;
    &-info {
      flex-grow: 1;
      .load-size {
        color: $color-secondary-text;
      }
      .load-progress {
        display: flex;
        gap: 16px;
        align-items: center;
        justify-content: space-between;
        &-bar {
          height: 8px;
          border-radius: 10px;
          background-color: $color-secondary-text;
          transition: 0.3s linear;
        }
      }
    }
    .delete-upload-wrap {
      height: 100%;
      align-self: flex-start;
      .delete-upload {
        width: 20px;
        height: 20px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $color-secondary-text;
      }
    }
  }
  .error-block {
    margin-bottom: 8px;
    p {
      color: #EA5252;
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
    }
  }
  &-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 16px;
    gap: 6px;
    &-title {
      display: flex;
      align-items: flex-start;
      p {
        margin-top: 3px;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
      }
    }
    &-body {
      ul {
        li {
          margin-top: 3px;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }
      }
    }
  }
}
</style>